import { Component, Input } from '@angular/core';
import { SnackbarLayout } from '@sb/library/base';

@Component({
    selector: 'lib-snackbar-layout',
    templateUrl: './snackbar-layout.component.html',
    styleUrls: ['./snackbar-layout.component.scss']
})
export class SnackbarLayoutComponent {

    @Input() layout: SnackbarLayout = SnackbarLayout.A;
    @Input() qaTag: string = '';

    get SnackbarLayout(): typeof SnackbarLayout {
        return SnackbarLayout;
    }
}
